/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:01]
Permissions to update outside the main branch: [false]
*/

import { DropDown, DropDownList, Input, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { getTradeOrgList } from 'axios/questionaryApi';
import useApi from 'hooks/useApi';
import { QuestionaryRequestFilter } from 'models/api/questionary';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { Col, FormGroup, Row } from 'reactstrap';

const QuestionaryFilter = () => {
    const api = useApi();
    const { t } = useTranslation();
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<QuestionaryRequestFilter>();
    const [tradeOrgs, setTradeOrgs] = useState<DropDown[]>([]);

    const changeProp = (value: string | DropDown, name: string) => {
        const updatedValue = (
            typeof value === 'string'
                ? { [name]: value }
                : { tradeOrg: value.name, tradeOrgId: value.id }
        ) as QuestionaryRequestFilter;
        setDraftFilter((prev) => ({ ...prev, ...updatedValue }));
    };

    const changeInputProp = (e: ChangeEvent<HTMLInputElement>) =>
        changeProp(e.target.value, e.target.name);

    const fetchingTradeOrgs = useQuery('tradeOrgs', () => getTradeOrgList(api, null), {
        onSuccess: (data) => {
            setTradeOrgs(data);
        },
        enabled: tradeOrgs.length === 0,
    });

    return (
        <>
            <Row>
                <Col>
                    <Input
                        value={draftFilter.id}
                        type="number"
                        name="id"
                        onChange={changeInputProp}
                        label={t('BackOfficeId')}
                    />
                </Col>
                <Col>
                    <Input
                        value={draftFilter.name}
                        name="name"
                        onChange={changeInputProp}
                        label={t('BackOfficeName')}
                    />
                </Col>
            </Row>
            <FormGroup>
                <DropDownList
                    name="trade-org"
                    value={draftFilter.tradeOrg ?? ''}
                    label={t('BackOfficeTradeOrgShort')}
                    items={tradeOrgs}
                    isLoading={fetchingTradeOrgs.isFetching}
                    setValue={(value) => changeProp(value, 'tradeOrg')}
                />
            </FormGroup>
        </>
    );
};

export default QuestionaryFilter;
